import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { postApi } from "../../../../utils/requestApi"
import { setRequestSaveData, setRequestSaveLoading } from "../Reducers/LinksTutoriaisReducer"

export default async function savePermissaoLista(dispatch: Function, data: {
    idUsuarioAdmin: number
    idLista: number
    usuarios: { idUsuario: number; flagVisualizar: number; flagEditarLista: number; flagEditarItem: number }[]
}) {
    dispatch(setRequestSaveLoading())
    const response: RequestResponsePattern<any> = await postApi({
        endpoint: `${DOMAIN}/LinksTutoriais/permissao/lista/save`,
        data,
    })
    if (response && !response.flagErro) {
        dispatch(setRequestSaveData(response))
        return response
    }
    throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
}
